const ACCESS_TOKEN_KEY = "kcg.access_token";

export function getAccessToken() {
  return window.sessionStorage.getItem(ACCESS_TOKEN_KEY);
}

function notifyAuthChanged() {
  window.dispatchEvent(new Event("kcg-auth-changed"));
}

export function setAccessToken(token) {
  if (!token) {
    window.sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  } else {
    window.sessionStorage.setItem(ACCESS_TOKEN_KEY, token);
  }
  notifyAuthChanged();
}

export function clearAccessToken() {
  window.sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  notifyAuthChanged();
}

export function buildLoginPath(nextPath = "/") {
  const safeNextPath = resolveNextPath(nextPath);
  return `/login?next=${encodeURIComponent(safeNextPath)}`;
}

export function resolveNextPath(candidate) {
  if (!candidate || typeof candidate !== "string") {
    return "/";
  }
  if (!candidate.startsWith("/") || candidate.startsWith("//")) {
    return "/";
  }
  if (candidate === "/login" || candidate.startsWith("/login?")) {
    return "/";
  }
  return candidate;
}

export function getCurrentPath() {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
